import React from 'react';
import './Leadership.css';

import Portraits from '../../../components/Portraits/Portraits';

const leadership = ( props ) => {
	if( props.people ) {
		props.people.map( pic => {
			pic.image = 'assets/images/portraits/' + pic.name.replace( / /g, '' ) + '.jpg';
			return null;
		});
	}
	
	return (
		<section id="Leadership" className="bg-color-2">
			<h2>Who's <span>Who In</span> Leadership</h2>
			<Portraits list={ props.people } />
		</section>
	);
};

export default leadership;



// WEBPACK FOOTER //
// ./src/pages/About/Leadership/Leadership.js